export default class ApiService {

	static get $inject(){
		return [
			'$q', '$http', '$cookies',
			'ApiService'
		];
	}

	constructor($q, $http, $cookies,
	            ApiService){

		this.api = ApiService.api;
		this.errors = ApiService.errors;
		this.successes = ApiService.successes;

		this.$q = $q;
		this.$http = $http;
		this.$cookies = $cookies;

	}

	get service(){
		return {
			/*updateFirmaware: {
			 name: 'updateFirmware',
			 humanName: 'Update Firmware',
			 request: {
			 type: 'PUT',
			 route: '/personal/access/updateFirmware',
			 data: [
			 { name: 'fileName', type: 'String', description: 'file name of firmware binary' }
			 ],
			 example: [
			 {
			 filename: 'Serenity_1_2_3_42.bin',
			 humanName: 'v1.2.3.42',
			 id: 1
			 },
			 {
			 filename: 'Serenity_1_2_4_52.bin',
			 humanName: 'v1.2.4.52',
			 id: 2
			 },
			 {
			 filename: 'Serenity_1_2_4_53.bin',
			 humanName: 'v1.2.4.53',
			 id: 3
			 },
			 {
			 filename: 'erenity_1_2_5_57.bin',
			 humanName: 'v1.2.5.57',
			 id: 4
			 }
			 ],
			 payload:{id: 1}
			 },
			 response: {
			 success: {
			 data: [
			 this.successes.status,
			 this.successes.state,
			 this.successes.message
			 ]
			 },
			 error: {
			 data: [
			 this.errors.status,
			 this.errors.state,
			 this.errors.message
			 ]
			 }
			 },
			 submit: (data)=>
			 this.$http({
			 url: this.api + '/personal/access/updateFirmware',
			 method: 'PUT',
			 data: data,
			 headers: { Authorization: 'Bearer ' + this.$cookies.get('token') }
			 })
			 },*/





//-router.put('/:mac/connect',                  auth.isAuthenticated(), helpers.panel.isValid(),    remoteAccessController.installerConnect);
//-router.put('/:mac/disconnect',               auth.isAuthenticated(), helpers.panel.isValid(),    remoteAccessController.installerDisconnect);
//-router.get('/:mac/status',                   auth.isAuthenticated(), remoteAccessController.installerStatusGet);
//-router.get('/:mac/config',                   auth.isAuthenticated(), remoteAccessController.installerConfigGet);
//-router.put('/:mac/config',                   auth.isAuthenticated(), remoteAccessController.installerConfigSet);

			connect: {
				name: 'Connect',
				humanName: 'Connect to panel as Installer, not remote password or user code are needed',
				request: {
					type: 'PUT',
					route: '/personal/access/:mac/connect',
					params: [
						{ name: 'mac', type: 'String', description: 'Panel MAC address' }
					],
					data: [
						{ name: 'remoteAccessPassword', type: 'String', description: 'Remote access password (optional)' }
					],
					param: ['0013A1022C7B']
				},
				response: {
					success: {
						data: [
							this.successes.status,
							this.successes.state,
							this.successes.message
						]
					},
					error: {
						data: [
							this.errors.status,
							this.errors.state,
							this.errors.message
						]
					}
				},
				submit: (data, param)=>
					this.$http({
						url: this.api + '/personal/access/' + param + '/connect',
						method: 'PUT',
						data: data,
						headers: { Authorization: 'Bearer ' + this.$cookies.get('token') }
					})
			},
			disconnect: {
				name: 'Disconnect',
				humanName: 'Disconnect as Installer',
				request: {
					type: 'PUT',
					route: '/personal/access/:mac/disconnect',
					params: [
						{ name: 'mac', type: 'String', description: 'Panel MAC address' }
					],
					param: ['0013A1022C7B']
					//payload:{}
				},
				response: {
					success: {
						data: [
							this.successes.status,
							this.successes.state,
							this.successes.message
						]
					},
					error: {
						data: [
							this.errors.status,
							this.errors.state,
							this.errors.message
						]
					}
				},
				submit: (data, param)=>
					this.$http({
						url: this.api + '/personal/access/' + param + '/disconnect',
						method: 'PUT',
						data: data,
						headers: { Authorization: 'Bearer ' + this.$cookies.get('token') }
					})
			},

			getStatus: {
				name: 'getStatus',
				humanName: 'Get system status',
				request: {
					type: 'GET',
					route: '/personal/access/:mac/status',
					params: [
						{ name: 'mac', type: 'String', description: 'Panel MAC address' }
					],
					param: ['0013A1022C7B']
				},
				response: {
					success: {
						data: [
							this.successes.status,
							this.successes.state,
							this.successes.message
						]
					},
					error: {
						data: [
							this.errors.status,
							this.errors.state,
							this.errors.message
						]
					}
				},
				submit: (data, param)=>
					this.$http({
						url: this.api + '/personal/access/' + param + '/status',
						method: 'GET',
						data: data,
						headers: { Authorization: 'Bearer ' + this.$cookies.get('token') }
					})
			},

			getConfig: {
				name: 'getConfig',
				humanName: 'Get config status',
				request: {
					type: 'GET',
					route: '/personal/access/:mac/config',
					params: [
						{ name: 'mac', type: 'String', description: 'Panel MAC address' }
					],
					param: ['0013A1022C7B']
				},
				response: {
					success: {
						data: [
							this.successes.status,
							this.successes.state,
							this.successes.message
						]
					},
					error: {
						data: [
							this.errors.status,
							this.errors.state,
							this.errors.message
						]
					}
				},
				submit: (data, param)=>
					this.$http({
						url: this.api + '/personal/access/' + param + '/config',
						method: 'GET',
						data: data,
						headers: { Authorization: 'Bearer ' + this.$cookies.get('token') }
					})
			},

			setConfig: {
				name: 'setConfig',
				humanName: 'Set config status',
				request: {
					type: 'PUT',
					route: '/personal/access/:mac/config',
					data: [
						{ name: 'config', type: 'Array', description: 'Array of config strings' }
					],
					params: [
						{ name: 'mac', type: 'String', description: 'Panel MAC address' }
					],
					example: JSON.stringify({ config: ["user_name=User 1|User 2|User 3|User 4|User 5|User 6|User 7|User 8|User 9|User 10|User 11|User 12|User 13|User 14|User 15|User 16|User 17|User 18|User 19|User 20|User 21|User 22|User 23|User 24|User 25|User 26|User 27|User 28|User 29|User 30|User 31|User 32|","user_code=FFFF1234|FFFFFFF1|FFFFFFFF|FFFFFFFF|FFFFFFFF|FFFFFFFF|FFFFFFFF|FFFFFFFF|FFFFFFFF|FFFFFFFF|FFFFFFFF|FFFFFFFF|FFFFFFFF|FFFFFFFF|FFFFFFFF|FFFFFFFF|FFFFFFFF|FFFFFFFF|FFFFFFFF|FFFFFFFF|FFFFFFFF|FFFFFFFF|FFFFFFFF|FFFFFFFF|FFFFFFFF|FFFFFFFF|FFFFFFFF|FFFFFFFF|FFFFFFFF|FFFFFFFF|FFF11111|FFFFFFFF|"]}),
					param: ['0013A1022C7B']
				},
				response: {
					success: {
						data: [
							this.successes.status,
							this.successes.state,
							this.successes.message
						]
					},
					error: {
						data: [
							this.errors.status,
							this.errors.state,
							this.errors.message
						]
					}
				},
				submit: (data, param)=>
					this.$http({
						url: this.api + '/personal/access/' + param + '/config',
						method: 'PUT',
						data: JSON.parse(data),
						headers: { Authorization: 'Bearer ' + this.$cookies.get('token') }
					})
			}


		}
	}

}






/** WEBPACK FOOTER **
 ** ./src/main/apiTest/services/api.service.install.access.js
 **/